// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Modal Card */
.modal-card {
  width: 420px;
  background: linear-gradient(180deg, #0f172a, #020617);
  padding: 26px;
  border-radius: 18px;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);
  color: white;
}

/* Header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  font-size: 20px;
  font-weight: 600;
}

.close-btn {
  cursor: pointer;
  font-size: 18px;
  opacity: 0.7;
}

.close-btn:hover {
  opacity: 1;
}

/* Subtitle */
.subtitle {
  margin: 10px 0 20px;
  font-size: 13px;
  color: #94a3b8;
}

/* Labels */
label {
  font-size: 13px;
  color: #cbd5f5;
  display: block;
  margin-bottom: 6px;
}

/* Inputs */
input {
  width: 100%;
  padding: 12px;
  margin-bottom: 16px;
  border-radius: 12px;
  border: 1px solid #1e293b;
  outline: none;
}

input::placeholder {
  color: #64748b;
}

input:focus {
  border-color: #facc15;
  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);
}

/* Actions */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 10px;
}

/* Buttons */
.cancel-btn {
  background: transparent;
  border: 1px solid #334155;
  color: #e5e7eb;
  padding: 10px 18px;
  border-radius: 12px;
  cursor: pointer;
}

.cancel-btn:hover {
  background: #020617;
}

.add-btn {
  background: #facc15;
  color: #020617;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
}

.add-btn:hover {
  background: #fde047;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Masters/UOM/AddUom/AddUom.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;AACd;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Overlay */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.65);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* Modal Card */\n.modal-card {\n  width: 420px;\n  background: linear-gradient(180deg, #0f172a, #020617);\n  padding: 26px;\n  border-radius: 18px;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);\n  color: white;\n}\n\n/* Header */\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h2 {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.close-btn {\n  cursor: pointer;\n  font-size: 18px;\n  opacity: 0.7;\n}\n\n.close-btn:hover {\n  opacity: 1;\n}\n\n/* Subtitle */\n.subtitle {\n  margin: 10px 0 20px;\n  font-size: 13px;\n  color: #94a3b8;\n}\n\n/* Labels */\nlabel {\n  font-size: 13px;\n  color: #cbd5f5;\n  display: block;\n  margin-bottom: 6px;\n}\n\n/* Inputs */\ninput {\n  width: 100%;\n  padding: 12px;\n  margin-bottom: 16px;\n  border-radius: 12px;\n  border: 1px solid #1e293b;\n  outline: none;\n}\n\ninput::placeholder {\n  color: #64748b;\n}\n\ninput:focus {\n  border-color: #facc15;\n  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.2);\n}\n\n/* Actions */\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 10px;\n}\n\n/* Buttons */\n.cancel-btn {\n  background: transparent;\n  border: 1px solid #334155;\n  color: #e5e7eb;\n  padding: 10px 18px;\n  border-radius: 12px;\n  cursor: pointer;\n}\n\n.cancel-btn:hover {\n  background: #020617;\n}\n\n.add-btn {\n  background: #facc15;\n  color: #020617;\n  font-weight: 600;\n  padding: 10px 20px;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n}\n\n.add-btn:hover {\n  background: #fde047;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
